import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@heroicons/react/outline";
import { useState } from "react";
interface PickerProps {
  handleCheckedDate: (date: Date) => void;
  checkedDate?: Date;
}
const Picker: React.FC<PickerProps> = ({ handleCheckedDate, checkedDate }) => {
  // weeks
  const WEEK_NAMES = ['日', '一', '二', '三', '四', '五', '六'];
  // 日历行数
  const LINES = [1, 2, 3, 4, 5, 6];
  // date
  const [date, setDate] = useState(checkedDate || new Date());
  // year
  const [year, setYear] = useState(date.getFullYear());
  // month
  const [month, setMonth] = useState(date.getMonth());

  // 每月多少天
  let MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  // 获取当前月有几天
  const getCurrentMonthDays = (year: number, month: number): number => {
    // 判断是否是闰年
    if ((year % 100 !== 0 && year % 4 === 0) || year % 400 === 0) {
      MONTH_DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    }
    return MONTH_DAYS[month]
  }

  // 通过年，月，日计算 日期
  const getDateByYearMonth = (year: number, month: number, day: number = 1): Date => {
    const date = new Date()
    date.setFullYear(year)
    date.setMonth(month, day)
    return date
  }
  // 处理点击day 
  const handleClickDay = (day: number) => {
    const date = getDateByYearMonth(year, month, day)
    handleCheckedDate(date)
  }
  // 计算当前月第一天是周几
  const getWeekByMonthFirstDay = (year: number, month: number): number => {
    var date = getDateByYearMonth(year, month)
    return date.getDay()
  }
  const weekDay = getWeekByMonthFirstDay(year, month)
  // 计算 当前单元格 显示的day
  const getDayText = (line: number, weekIndex: number, weekDay: number, monthDays: number): any => {
    const number = line * 7 + weekIndex - weekDay + 1
    if (number <= 0 || number > monthDays) {
      return <div className="h-0" key={weekIndex}>&nbsp;</div>
    }
    return <div
      key={weekIndex}
      onClick={() => handleClickDay(number)}
    >
      <span className={`inline-block w-6 h-6 text-xs leading-6 cursor-pointer rounded-full 
        hover:bg-sprimary-400 hover:text-white
        ${date.getDate() === number && month === date.getMonth() ? 'bg-sprimary-400 text-white' : 'bg-gray-100 '}
      `}>{number}</span>
    </div>
  }
  // 前后改变月份
  const monthChange = (monthChanged: number) => {
    const monthAfter = month + monthChanged
    const date = getDateByYearMonth(year, monthAfter)
    setMonth(date.getMonth())
    setYear(date.getFullYear())
  }
  // 格式化月
  const formatMonth = (num: number): string => {
    var _num = num + 1
    return _num < 10 ? `0${_num}` : `${_num}`
  }

  return (
    <div className="bg-white w-64 absolute shadow-lg">
      {/* header  */}
      <div className="flex justify-between w-full border-b p-3">
        <ChevronLeftIcon className="w-5 cursor-pointer hover:text-sprimary-600 text-gray-400" onClick={() => {
          monthChange(-1);
        }} />
        <div className="text-sm font-semibold">
          {year}年 {formatMonth(month)}月
        </div>
        <ChevronRightIcon className="w-5 cursor-pointer hover:text-sprimary-600 text-gray-400" onClick={() => {
          monthChange(1);
        }} />
      </div>
      {/* week */}
      <div className="grid grid-flow-col grid-cols-7 text-center px-2">
        {
          WEEK_NAMES.map((week, key) => {
            return <div className="py-2 text-sm" key={key}>{week}</div>
          })
        }
      </div>
      {/* day */}
      {
        LINES.map((l, line) => {
          return <div key={line} className="grid grid-flow-col grid-cols-7 text-center mb-2 px-2">
            {
              WEEK_NAMES.map((week, weekIndex) => {
                return getDayText(line, weekIndex, weekDay, getCurrentMonthDays(year, month))
              })
            }
          </div>
        })
      }
    </div>

  )
}
export default Picker;
